import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { Button as MaterialButton, IconButton } from '@mui/material';
export function Brand({ light = false }) {
  return <Link to="/" className={`fl-brand ${light ? 'fl-brand-light' : ''}`} aria-label="Firelabs, homepage"><span className="fl-brand-mark"><Icon name="flame" size={27} /></span>firelabs<span className="fl-brand-dot">.</span></Link>;
}
export function Button({ children, variant = '', className = '', ...props }) {
  const materialVariant = variant === 'outline' ? 'outlined' : variant === 'text' ? 'text' : 'contained';
  return <MaterialButton size="large" variant={materialVariant} className={`fl-button ${className}`} {...props}>{children}</MaterialButton>;
}
export function Notice({ children, type = 'error', onClose }) {
  if (!children) return null;
  return <div className={`fl-notice fl-notice-${type}`} role={type === 'error' ? 'alert' : 'status'}>{children}{onClose && <IconButton size="small" aria-label="Chiudi messaggio" onClick={onClose}><Icon name="close" size={16} /></IconButton>}</div>;
}
export function Modal({ title, subtitle, onClose, children, wide = false, eyebrow = 'FIRELABS CONSOLE' }) {
  const ref = useRef(null);
  useEffect(() => {
    const previous = document.activeElement; const dialog = ref.current;
    dialog.showModal(); const close = event => { event.preventDefault(); onClose(); };
    dialog.addEventListener('cancel', close);
    return () => { dialog.removeEventListener('cancel', close); dialog.close(); previous?.focus(); };
  }, [onClose]);
  return <dialog ref={ref} className={`fl-modal ${wide ? 'fl-modal-wide' : ''}`} aria-labelledby="fl-modal-title"><div className="fl-modal-head"><div><span className="fl-eyebrow">{eyebrow}</span><h2 id="fl-modal-title">{title}</h2>{subtitle && <p>{subtitle}</p>}</div><IconButton aria-label="Chiudi finestra" onClick={onClose}><Icon name="close" /></IconButton></div>{children}</dialog>;
}
export const date = value => new Date(value).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' });
export const statuses = { QUEUED: 'In coda', SENDING: 'In invio', SENT: 'Accettata SMTP', FAILED: 'Invio non confermato', UNKNOWN: 'Esito incerto', SKIPPED: 'Non inviata' };
